const hours = (time: number) => Math.floor(time / 60 / 60);
const minutes = (time: number) => Math.floor(time / 60) - hours(time) * 60;
const seconds = (time: number) => time % 60;

export const getFormattedTime = (time: number) =>
  [
    minutes(time).toString().padStart(2, '0'),
    seconds(time).toString().padStart(2, '0'),
  ].join(':');
